import { WarningFilled } from "@ant-design/icons";
import { Button, Flex, Modal, Typography } from "antd";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";

interface Props {
    open: boolean;
    onCancel?: () => void;
    onConfirm?: () => void;
    title?: string;
    loading?: boolean;
}

export const DeleteModal: FC<Props> = ({ open, title, onCancel, onConfirm, loading }) => {
    const { t } = usePaldockTranslation("ui.delete-modal");

    return (
        <Modal open={open} onCancel={onCancel} className={"p-[20px]"} footer={[
            <Flex key="footer-buttons" vertical={false} gap={8} justify={"center"}>
                <Button size={"large"} onClick={onCancel} disabled={loading}>
                    {t("no_keep")}
                </Button>
                <Button size={"large"} type={"primary"} danger={true} onClick={onConfirm} loading={loading}>
                    {t("yes_delete")}
                </Button>
            </Flex>
        ]} destroyOnClose>
            <Flex vertical={true} align={"center"} gap={24} justify={"center"}>
                <WarningFilled className={"w-[63px] h-[55px]"} style={{ fontSize: 63, color: '#FF4D4F' }} />
                <Flex vertical={true} align={"center"} justify={"center"}>
                    <Typography.Title level={2}>{t("delete_title", { item: title })}</Typography.Title>
                    <Typography.Paragraph className={"text-center"}>
                        {t("delete_confirmation", { item: title })}
                    </Typography.Paragraph>
                </Flex>
            </Flex>
        </Modal>
    );
}
